"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var surface_1 = require("../surface");
var searchBar_1 = require("../searchBar");
var ui_virtualized_1 = require("@vidazoo/ui-virtualized");
var ItemsList = /** @class */ (function (_super) {
    tslib_1.__extends(ItemsList, _super);
    function ItemsList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onSelectItem = function (value, label, isNew, item) {
            if (!utils_1.isDefined(value) || !utils_1.isDefined(label)) {
                return;
            }
            var onSelectItem = _this.props.onSelectItem;
            _this.resetActiveIndex();
            onSelectItem && onSelectItem(value, label, isNew, item);
        };
        _this.onSearch = function (e) {
            _this.handleSearch(e.target.value);
        };
        _this.onClearSearch = function () {
            _this.handleSearch("");
        };
        _this.onSearchKeyDown = function (e) {
            switch (e.keyCode) {
                case 38:
                    utils_1.pauseEvent(e);
                    _this.handleUpKey();
                    break;
                case 40:
                    utils_1.pauseEvent(e);
                    _this.handleDownKey();
                    break;
                case 13:
                    utils_1.pauseEvent(e);
                    _this.handleSelectKey(e);
                    break;
                default:
                    _this.scrollToRow(0);
            }
        };
        _this.renderListItem = function (itemIndex, viewportIndex) {
            var _a = _this.props, children = _a.children, selected = _a.selected;
            var activeIndex = _this.state.activeIndex;
            var child = React.Children.only(children[itemIndex]);
            return React.cloneElement(child, {
                onItemSelect: _this.onSelectItem,
                selected: utils_1.isDefined(child.props.value) && child.props.value === selected,
                active: activeIndex === itemIndex,
                key: itemIndex
            });
        };
        _this.scrollable = React.createRef();
        _this.state = { activeIndex: -1 };
        return _this;
    }
    ItemsList.prototype.componentDidMount = function () {
        var onRef = this.props.onRef;
        onRef && onRef(this);
    };
    ItemsList.prototype.componentWillUnmount = function () {
        var onRef = this.props.onRef;
        onRef && onRef(undefined);
    };
    ItemsList.prototype.resetActiveIndex = function () {
        var activeIndex = this.state.activeIndex;
        if (activeIndex !== -1) {
            this.setState({ activeIndex: -1 });
        }
    };
    ItemsList.prototype.handleSearch = function (value) {
        var onSearch = this.props.onSearch;
        this.resetActiveIndex();
        onSearch && onSearch(value);
    };
    ItemsList.prototype.handleUpKey = function () {
        var children = this.props.children;
        var activeIndex = this.state.activeIndex;
        var childrenArray = React.Children.toArray(children);
        var nextState = {};
        if (activeIndex > 0) {
            nextState.activeIndex = activeIndex - 1;
        }
        else {
            nextState.activeIndex = childrenArray.length - 1;
        }
        this.updateScrollActiveState(nextState);
    };
    ItemsList.prototype.handleDownKey = function () {
        var children = this.props.children;
        var activeIndex = this.state.activeIndex;
        var childrenArray = React.Children.toArray(children);
        var nextState = {};
        if (activeIndex === childrenArray.length - 1) {
            nextState.activeIndex = 0;
        }
        else {
            nextState.activeIndex = activeIndex + 1;
        }
        this.updateScrollActiveState(nextState);
    };
    ItemsList.prototype.updateScrollActiveState = function (nextState) {
        var _this = this;
        this.setState(nextState, function () { return _this.scrollToRow(_this.state.activeIndex); });
    };
    ItemsList.prototype.getItemByIndex = function (index) {
        var children = this.props.children;
        var childArray = React.Children.toArray(children);
        var child = childArray[index];
        if (child) {
            return {
                value: child.props.value,
                label: child.props.label,
                item: child.props.item
            };
        }
        return null;
    };
    /**
     * @deprecated
     * @param e keyboard event
     */
    ItemsList.prototype.handleSelectKey = function (e) {
        var _a = this.props, allowCreate = _a.allowCreate, allowMultiCreate = _a.allowMultiCreate;
        var activeIndex = this.state.activeIndex;
        var tuple = this.getItemByIndex(activeIndex);
        var value, label, isNew, item;
        if (tuple) {
            value = tuple.value;
            label = tuple.label;
            item = tuple.item;
            isNew = false;
        }
        else if (allowMultiCreate && e.target.value) {
            var str = e.target.value;
            var array = str.trim().split(/[ ,]+/);
            for (var i = 0, len = array.length; i < len; i++) {
                value = label = array[i];
                isNew = true;
                this.resetActiveIndex();
                this.onSelectItem(value, label, isNew);
            }
            return;
        }
        else if (allowCreate && e.target.value) {
            value = label = e.target.value;
            isNew = true;
        }
        this.resetActiveIndex();
        this.onSelectItem(value, label, isNew, item);
    };
    ItemsList.prototype.scrollToRow = function (rowIndex) {
        var rowHeight = this.props.itemHeight * 10;
        this.scrollable.current.scrollTo(this.scrollable.current.scrollLeft, rowHeight * rowIndex);
    };
    ItemsList.prototype.renderSearchBar = function () {
        var _a = this.props, theme = _a.theme, searchable = _a.searchable, query = _a.query, autoFocus = _a.autoFocus;
        if (!searchable) {
            return null;
        }
        return (React.createElement(searchBar_1.default, { fill: true, small: true, inner: true, autoFocus: autoFocus, value: query, className: theme.search, onChange: this.onSearch, onClear: this.onClearSearch, onKeyDown: this.onSearchKeyDown }));
    };
    ItemsList.prototype.renderEmptySearchMessage = function () {
        var _a = this.props, children = _a.children, searchable = _a.searchable, emptySearchMessage = _a.emptySearchMessage;
        if (searchable && emptySearchMessage && !children.length) {
            return emptySearchMessage;
        }
        return null;
    };
    ItemsList.prototype.render = function () {
        var _a = this.props, children = _a.children, theme = _a.theme, className = _a.className, width = _a.width, surfaceLevel = _a.surfaceLevel, selected = _a.selected, maxItems = _a.maxItems, itemHeight = _a.itemHeight, searchable = _a.searchable, query = _a.query, onSearch = _a.onSearch, autoFocus = _a.autoFocus, onRef = _a.onRef, onSelectItem = _a.onSelectItem, allowCreate = _a.allowCreate, emptySearchMessage = _a.emptySearchMessage, allowMultiCreate = _a.allowMultiCreate, others = tslib_1.__rest(_a, ["children", "theme", "className", "width", "surfaceLevel", "selected", "maxItems", "itemHeight", "searchable", "query", "onSearch", "autoFocus", "onRef", "onSelectItem", "allowCreate", "emptySearchMessage", "allowMultiCreate"]);
        var childrenLen = children.length, viewportRows = Math.min(maxItems || childrenLen, childrenLen);
        return (React.createElement(surface_1.default, { className: theme.surface, level: surfaceLevel },
            this.renderSearchBar(),
            this.renderEmptySearchMessage(),
            React.createElement(ui_virtualized_1.Virtualized, { viewportWidth: width, calculateInitialWidth: true, className: theme.list, ref: this.scrollable, rowHeight: itemHeight * 10, itemsCount: children.length, viewportRows: viewportRows, renderRow: this.renderListItem, overscanItems: 5, extraData: {} })));
    };
    ItemsList.defaultProps = {
        surfaceLevel: 2,
        itemHeight: 3.7,
        query: "",
        autoFocus: true
    };
    return ItemsList;
}(React.Component));
exports.default = ItemsList;
